export const letterFromIndex = (index: number): string =>
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')[index];
